import React from 'react'

import { GridProps } from './Grid.types'
import styles from './Grid.module.scss'

/**
 * Grid component that provides a 12-column layout system
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child elements to render within the grid
 * @param {string} [props.className] - Additional CSS class names
 * @param {string} [props.gap] - Custom gap size (e.g., '1rem', '16px')
 * @param {boolean} [props.fluid] - Whether the grid should be fluid width
 */
export default function Grid({
  children,
  className = '',
  gap,
  fluid = false,
  noPadding = false,
}: GridProps) {
  const gridStyle = {
    ...(gap && { '--grid-gap': gap }),
  } as React.CSSProperties

  // Base class first, then variants, then custom class
  const gridClasses = [
    styles.grid,
    fluid ? styles.fluid : '',
    noPadding ? styles.noPadding : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      style={gridStyle}
      className={gridClasses}
    >
      {children}
    </div>
  )
}
